import React from 'react';

import { connect } from 'react-redux';
import { Footer, CreditInfo } from 'ui/toyota/containers';
import { Logo } from 'ui/toyota/outlines';

import styles from './styles';

const {
    MainContainer,
    MainBox,
    MainHeader,
    MainHeaderContainer,
    MainLogo,
    LogoImage,
} = styles;

class Status extends React.Component {
    render() {
        const {
            status: {
                data: {
                    order,
                    order: {
                        merchantOrderNumber,
                    },
                    status,
                    statusDescriprion,
                },
            },
            gotStatusPage,
            error,
            isLoadedStatus,
        } = this.props;

        return (
            <MainContainer>
                <MainHeaderContainer>
                    <MainHeader>
                        Информация о заказе № {merchantOrderNumber}
                    </MainHeader>
                    <MainLogo><LogoImage src={Logo} /></MainLogo>
                </MainHeaderContainer>
                <MainBox>
                    <CreditInfo
                        order={order}
                        status={status}
                        statusDescriprion={statusDescriprion}
                        gotStatusPage={gotStatusPage}
                        error={error}
                        isLoadedStatus={isLoadedStatus}
                    />
                </MainBox>
                <Footer />
            </MainContainer>
        );
    }
}

export default connect(
    state => ({
        status: state.brand.status,
    }),
    null,
)(Status);
